export default __webpack_public_path__ + "static/media/Lab.30d59b4f.svg";